import {EstimationModel} from "../../firebase/index.js";


export const additionalHeaders = {
	  pp: "^ Per person",
	  pppn: "# Per person per night",
	  pppd: "## Per person per day"
};

export const estKeys = {
	  destination: "destination",
	  persons: "persons",
	  nights: "nights",
	  primaryFarePP: "primaryFarePP",
	  secondaryFarePP: "secondaryFarePP",
	  roomCostPPPN: "roomCostPPPN",
	  foodCostPPPD: "foodCostPPPD",
	  sightseeing: "sightseeing",
	  shopping: "shopping",
	  extras: "extras",
	  total: "total",
	  perHead: "perHead"
};

export const rowKeyHeaders = {
	  [estKeys.destination]: "Destination",
	  [estKeys.persons]: "Persons",
	  [estKeys.nights]: "Night(s)",
	  [estKeys.primaryFarePP]: "Primary fare ^", // PER PERSON
	  [estKeys.secondaryFarePP]: "Secondary fare ^", // PER PERSON
	  [estKeys.roomCostPPPN]: "Room #", // PER PERSON PER NIGHT
	  [estKeys.foodCostPPPD]: "Food ##", // PER PERSON PER DAY
	  [estKeys.sightseeing]: "Sightseeing",
	  [estKeys.shopping]: "Shopping",
	  [estKeys.extras]: "Extras",
	  [estKeys.total]: "Total",
	  [estKeys.perHead]: "Per head"
};

export const rowKeyEstimation: EstimationModel = new EstimationModel(
		  rowKeyHeaders.destination,
		  rowKeyHeaders.persons,
		  rowKeyHeaders.nights,
		  rowKeyHeaders.primaryFarePP,
		  rowKeyHeaders.secondaryFarePP,
		  rowKeyHeaders.roomCostPPPN,
		  rowKeyHeaders.foodCostPPPD,
		  rowKeyHeaders.sightseeing,
		  rowKeyHeaders.shopping,
		  rowKeyHeaders.extras,
		  rowKeyHeaders.total,
		  rowKeyHeaders.perHead
);